import React from 'react';
import classNames from 'classnames';
import { Stack, ControlLink } from '@moda/om';
import { hrefFor } from '../../routers';
import { useCart, CartVersion } from '../../hooks/useCart';

import './RewardPointsPreview.scss';

interface Props {
  theme?: 'box' | 'simple';
}

export const RewardPointsPreview: React.FC<Props> = ({ theme = 'box' }) => {
  const { cart } = useCart();

  if (cart.attributes.version === CartVersion.MiniBag) return null;

  const points = cart.attributes.rewardPoints;

  return points ? (
    <Stack space={2} className={classNames('RewardPointsPreview', `RewardPointsPreview--${theme}`)}>
      <div className="RewardPointsPreview__title">M'O Rewards</div>
      <div
        className="RewardPointsPreview__content"
        data-testid="points"
      >{`You will earn ${points} points from this purchase.`}</div>
      <ControlLink to={hrefFor.AccountRewards()}>See my rewards</ControlLink>
    </Stack>
  ) : null;
};
